import axios from "axios";
import { API_URL } from "../../modules/auth/core/_requests";
import {
  ReportMetadata,
  ReportDataRequest,
  ReportDataResponse,
  ReportListResponse,
} from "./types";

const REPORTS_BASE = "/api/reports";

/**
 * Get list of all available reports.
 */
export function getAllReports(): Promise<{ data: ReportListResponse }> {
  return axios.get(API_URL + REPORTS_BASE);
}

/**
 * Get metadata for a specific report (columns, filters, chart config).
 */
export function getReportMetadata(
  reportId: number
): Promise<{ data: ReportMetadata }> {
  return axios.get(API_URL + REPORTS_BASE + `/${reportId}/metadata`);
}

/**
 * Get report data with filters, pagination, and sorting.
 */
export function getReportData(
  reportId: number,
  request: ReportDataRequest
): Promise<{ data: ReportDataResponse }> {
  return axios.post(API_URL + REPORTS_BASE + `/${reportId}/data`, request);
}

/**
 * Export report data as CSV.
 */
export function exportReportCsv(
  reportId: number,
  request: ReportDataRequest
): Promise<{ data: Blob }> {
  return axios.post(API_URL + REPORTS_BASE + `/${reportId}/export/csv`, request, {
    responseType: "blob",
  });
}

/**
 * Download a file blob with the given filename.
 */
export function downloadFile(blob: Blob, filename: string) {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
}
